export function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}
export function isTestEnv() {
  if (window.location.hostname === 'localhost') {
    return true;
  }
  if (window.location.hostname === 'hosting-xr.jp.ngrok.io') {
    return true;
  }
  return false;
}

export function isStripeZeroDecimal(currency) {
  return ['jpy', 'krw'].includes(currency);
}

export async function timeoutRetry(promiseTask, promiseFailedTask = undefined, retryTimes = 3) {
  for (let retry = 0; retry < retryTimes; retry++) {
    try {
      return await promiseTask();
    } catch (e) {
      if (e.code === 'internal') {
        continue;
      }
      throw e;
    }
  }
  if (promiseFailedTask !== undefined) {
    await promiseFailedTask();
  } else {
    const err = new Error('internal');
    err.code = 'internal';
    throw err;
  }
}
